// Note: All of these are v2 templates
const supportedSections = {
  // Modern
  '5ed43ef1-e39f-4279-93a0-c899246ae7c0': [
    {
      id: 'header_and_introduction',
      label: 'Home',
      disabled: true
    },
    {
      id: 'contact_form',
      label: 'Contact',
      disabled: false
    },
    {
      id: 'testimonials',
      label: 'Testimonials',
      disabled: false
    },
    {
      id: 'about',
      label: 'About',
      disabled: false
    },
    {
      id: 'services',
      label: 'Services',
      disabled: false
    },
    {
      id: 'products',
      label: 'Products',
      disabled: false
    },
      {
    id: 'portfolio',
    label: 'Portfolio',
    disabled: false,
    isGridOnly: true
    },
    {
      id: 'store',
      label: 'Store',
      disabled: false,
      isGridOnly: true
    },
    {
      id: 'appointments',
      label: 'Appointments',
      disabled: false,
      isGridOnly: true
    },
    {
      id: 'blog',
      label: 'Blog',
      disabled: false,
      isGridOnly: true
    },
    {
      id: 'team',
      label: 'Team',
      disabled: false,
      isGridOnly: true
    },
    {
      id: 'faq',
      label: 'Frequently Asked Questions (FAQs)',
      disabled: false,
      isGridOnly: true
    },
    {
      id: 'footer',
      label: 'Footer',
      disabled: true
    },
  ],
  // Bold
  '043808e9-5440-4359-a5e0-c82e08dd1cca': [
    {
      id: 'header_and_introduction',
      label: 'Home',
      disabled: true
    },
    {
      id: 'contact_form',
      label: 'Contact',
      disabled: false
    },
    {
      id: 'testimonials',
      label: 'Testimonials',
      disabled: false
    },
    {
      id: 'about',
      label: 'About',
      disabled: false
    },
    {
      id: 'services',
      label: 'Services',
      disabled: false
    },
    {
      id: 'products',
      label: 'Products',
      disabled: false
    },
      {
    id: 'portfolio',
    label: 'Portfolio',
    disabled: false,
    isGridOnly: true
    },
    {
      id: 'store',
      label: 'Store',
      disabled: false,
      isGridOnly: true
    },
    {
      id: 'appointments',
      label: 'Appointments',
      disabled: false,
      isGridOnly: true
    },
    {
      id: 'blog',
      label: 'Blog',
      disabled: false,
      isGridOnly: true
    },
    {
      id: 'team',
      label: 'Team',
      disabled: false,
      isGridOnly: true
    },
    {
      id: 'faq',
      label: 'Frequently Asked Questions (FAQs)',
      disabled: false,
      isGridOnly: true
    },
    {
      id: 'footer',
      label: 'Footer',
      disabled: true
    },
  ],
  // Classic
  '9cdab1fc-9b71-4a2b-86e4-1fdf6273a4c2': [
    {
      id: 'header_and_introduction',
      label: 'Home',
      disabled: true
    },
    {
      id: 'contact_form',
      label: 'Contact',
      disabled: false
    },
    {
      id: 'testimonials',
      label: 'Testimonials',
      disabled: false
    },
    {
      id: 'about',
      label: 'About',
      disabled: false
    },
    {
      id: 'services',
      label: 'Services',
      disabled: false
    },
    {
      id: 'products',
      label: 'Products',
      disabled: false
    },
      {
    id: 'portfolio',
    label: 'Portfolio',
    disabled: false,
    isGridOnly: true
    },
    {
      id: 'store',
      label: 'Store',
      disabled: false,
      isGridOnly: true
    },
    {
      id: 'appointments',
      label: 'Appointments',
      disabled: false,
      isGridOnly: true
    },
    {
      id: 'blog',
      label: 'Blog',
      disabled: false,
      isGridOnly: true
    },
    {
      id: 'team',
      label: 'Team',
      disabled: false,
      isGridOnly: true
    },
    {
      id: 'faq',
      label: 'Frequently Asked Questions (FAQs)',
      disabled: false,
      isGridOnly: true
    },
    {
      id: 'footer',
      label: 'Footer',
      disabled: true
    },
  ],
  // Professional
  '75a3d801-89b2-4ac5-8fdc-a889eb7cfac1': [
    {
      id: 'header_and_introduction',
      label: 'Home',
      disabled: true
    },
    {
      id: 'contact_form',
      label: 'Contact',
      disabled: false
    },
    {
      id: 'testimonials',
      label: 'Testimonials',
      disabled: false
    },
    {
      id: 'about',
      label: 'About',
      disabled: false
    },
    {
      id: 'services',
      label: 'Services',
      disabled: false
    },
    {
      id: 'products',
      label: 'Products',
      disabled: false
    },
      {
    id: 'portfolio',
    label: 'Portfolio',
    disabled: false,
    isGridOnly: true
    },
    {
      id: 'store',
      label: 'Store',
      disabled: false,
      isGridOnly: true
    },
    {
      id: 'appointments',
      label: 'Appointments',
      disabled: false,
      isGridOnly: true
    },
    {
      id: 'blog',
      label: 'Blog',
      disabled: false,
      isGridOnly: true
    },
    {
      id: 'team',
      label: 'Team',
      disabled: false,
      isGridOnly: true
    },
    {
      id: 'faq',
      label: 'Frequently Asked Questions (FAQs)',
      disabled: false,
      isGridOnly: true
    },
    {
      id: 'footer',
      label: 'Footer',
      disabled: true
    },
  ],
  // Playful
  '0c3f5491-7594-43d0-9fa8-b42877c50732': [
    {
      id: 'header_and_introduction',
      label: 'Home',
      disabled: true
    },
    {
      id: 'contact_form',
      label: 'Contact',
      disabled: false
    },
    {
      id: 'testimonials',
      label: 'Testimonials',
      disabled: false
    },
    {
      id: 'about',
      label: 'About',
      disabled: false
    },
    {
      id: 'services',
      label: 'Services',
      disabled: false
    },
    {
      id: 'products',
      label: 'Products',
      disabled: false
    },
      {
    id: 'portfolio',
    label: 'Portfolio',
    disabled: false,
    isGridOnly: true
    },
    {
      id: 'store',
      label: 'Store',
      disabled: false,
      isGridOnly: true
    },
    {
      id: 'appointments',
      label: 'Appointments',
      disabled: false,
      isGridOnly: true
    },
    {
      id: 'blog',
      label: 'Blog',
      disabled: false,
      isGridOnly: true
    },
    {
      id: 'team',
      label: 'Team',
      disabled: false,
      isGridOnly: true
    },
    {
      id: 'faq',
      label: 'Frequently Asked Questions (FAQs)',
      disabled: false,
      isGridOnly: true
    },
    {
      id: 'footer',
      label: 'Footer',
      disabled: true
    },
  ]
}

const defaultSections = [
  {
    id: 'header_and_introduction',
    label: 'Home',
    disabled: true
  },
  {
    id: 'contact_form',
    label: 'Contact',
    disabled: false
  },
  {
    id: 'testimonials',
    label: 'Testimonials',
    disabled: false
  },
  {
    id: 'about',
    label: 'About',
    disabled: false
  },
  {
    id: 'services',
    label: 'Services',
    disabled: false
  },
  {
    id: 'products',
    label: 'Products',
    disabled: false
  },
  {
    id: 'portfolio',
    label: 'Portfolio',
    disabled: false,
    isGridOnly: true
  },
  {
    id: 'store',
    label: 'Store',
    disabled: false,
    isGridOnly: true
  },
  {
    id: 'appointments',
    label: 'Appointments',
    disabled: false,
    isGridOnly: true
  },
  {
    id: 'blog',
    label: 'Blog',
    disabled: false,
    isGridOnly: true
  },
  {
    id: 'team',
    label: 'Team',
    disabled: false,
    isGridOnly: true
  },
  {
    id: 'faq',
    label: 'Frequently Asked Questions (FAQs)',
    disabled: false,
    isGridOnly: true
  },
  {
    id: 'footer',
    label: 'Footer',
    disabled: true
  },
]

const getSupportedSections = (templateId, sku, isGrid) => {
  const sections = supportedSections[templateId] || defaultSections;
  
  let filteredSections = sections;
  
  if (sku === 'WEBSITEONLY') {
    filteredSections = sections.filter(section => 
      section.id !== 'services' && section.id !== 'products'
    );
  }
  
  if (sku === 'ECOMBOOKINGS') {
    filteredSections = sections.filter(section => 
      section.id !== 'products'
    );
  }
  
  // For ECOMPREMIUM or any other SKU, return all sections
  // But temporarily hide 'Products' and 'Services' from all templates 
  // https://jira.newfold.com/browse/SP-417692
  const remainingSections = filteredSections.filter(section => 
    section.id !== 'services' && section.id !== 'products' && (isGrid ? true : !section.isGridOnly)
  );
  return remainingSections;
}

export default getSupportedSections